import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const blogDataApi = createApi({
  reducerPath: "blogDataApi",
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_API + "blog",
    prepareHeaders: (headers, { getState }) => {
      const token = getState()?.userSlice?.token;
      if (token) headers.set("Authorization", `Bearer ${token}`);
      return headers;
    },
  }),
  endpoints: (builder) => ({
    // Get all blogs (public) – supports pagination, search, sort
    getSettingBlog: builder.query({
      query: () => {
        return {
          url: `/blog-settings`,
          method: "GET",
        };
      },
      // Optional: keep previous data while fetching new page
      keepUnusedDataFor: 60,
    }),
    getAllBlogs: builder.query({
      query: ({
        page = 1,
        limit = 10,
        sort = "-createdAt",
        search = "",
        filter = [],
      }) => {
        const params = new URLSearchParams();
        params.append("page", page);
        params.append("limit", limit);
        if (sort) params.append("sort", sort);
        if (search) params.append("search", search);
        if (filter.length > 0) {
          filter.forEach((element) => {
            const allFilters = element.split(":");
            params.append(allFilters[0], allFilters[1]);
          });
        }
        return {
          url: `/view-blog/all?${params.toString()}`,
          method: "GET",
        };
      },
      // Optional: keep previous data while fetching new page
      keepUnusedDataFor: 60,
    }),

    // Get single blog by ID
    getOneBlog: builder.query({
      query: ({ id }) => ({
        url: `/view-blog/${id}`,
        method: "GET",
      }),
    }),

    // (Optional) Get blogs grouped by selected categories
    getSelectedCategoryBlogs: builder.query({
      query: ({ search = "", sort = "-createdAt", limit = 200 }) => {
        const params = new URLSearchParams();
        if (search) params.append("search", search);
        if (sort) params.append("sort", sort);
        if (limit) params.append("limit", limit);
        return {
          url: `/view-blog/selected?${params.toString()}`,
          method: "GET",
        };
      },
    }),

    // (Optional) Get "rest" blogs (not in selected categories)
    getRestBlogs: builder.query({
      query: ({ search = "", sort = "-createdAt", limit = 200, page = 1 }) => {
        const params = new URLSearchParams();
        if (search) params.append("search", search);
        if (sort) params.append("sort", sort);
        if (limit) params.append("limit", limit);
        if (page) params.append("page", page);
        return {
          url: `/view-blog/rest?${params.toString()}`,
          method: "GET",
        };
      },
    }),
  }),
});

// Export hooks for usage in components
export const {
  useGetSettingBlogQuery,
  useGetAllBlogsQuery,
  useGetOneBlogQuery,
  useGetSelectedCategoryBlogsQuery,
  useGetRestBlogsQuery,
} = blogDataApi;
